import { render } from "./DetailTargetDistributorList.vue?vue&type=template&id=69360526"
import script from "./DetailTargetDistributorList.vue?vue&type=script&lang=js"
export * from "./DetailTargetDistributorList.vue?vue&type=script&lang=js"
script.render = render

export default script